import React from 'react';
import { ConfirmationModal as ConfirmationModalUDL } from './component';
import { ConfirmationModal as ConfirmationModalLegacy } from './component.legacy';
import { Props } from './types';
import { convertLegacyModalSize } from '../../utils/legacyModalSize';

export { type Props as ConfirmationModaProps } from './types';

export const ConfirmationModal = <D, C>(props: Props<D, C>) => {
  if (props.renderAsLegacy) {
    return <ConfirmationModalLegacy {...props} />;
  }
  return <ConfirmationModalUDL {...props} size={props.size && convertLegacyModalSize(props.size)} />;
};
